import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, easeInOut, motion } from 'framer-motion';
import { useTimeout } from 'usehooks-ts';
const successColor = 'var(--text-color-success)';
export type SuccessCheckProps = {
  animationStart: boolean;
  onComplete?: () => void;
  size?: number;
};
const SuccessCheck = t0 => {
  const $ = _c(17);
  const {
    onComplete,
    animationStart,
    size: t1
  } = t0;
  const size = t1 === undefined ? 32 : t1;
  let t2;
  if ($[0] !== animationStart || $[1] !== onComplete) {
    t2 = () => {
      if (animationStart && onComplete) {
        onComplete();
      }
    };
    $[0] = animationStart;
    $[1] = onComplete;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useTimeout(t2, animationStart ? 1000 : null);
  const scale = size / 40;
  const checkPath = `M${1.59833 * scale} ${7.65486 * scale}L${2.41521 * scale} ${9.39584 * scale}C${3.0626 * scale} ${10.7606 * scale} ${4.99533 * scale} ${10.8551 * scale} ${5.75385 * scale} ${9.53316 * scale}L${10.0737 * scale} ${2.00464 * scale}`;
  const circlePath = `M${1.86441 * scale} ${15.3009 * scale}C${1.86441 * scale} ${7.75966 * scale} ${7.97783 * scale} ${1.64624 * scale} ${15.5191 * scale} ${1.64624 * scale}C${23.0604 * scale} ${1.64624 * scale} ${29.1738 * scale} ${7.75966 * scale} ${29.1738 * scale} ${15.3009 * scale}C${29.1738 * scale} ${22.8422 * scale} ${23.0604 * scale} ${28.9557 * scale} ${15.5191 * scale} ${28.9557 * scale}C${7.97783 * scale} ${28.9557 * scale} ${1.86441 * scale} ${22.8422 * scale} ${1.86441 * scale} ${15.3009 * scale}Z`;
  let t3;
  if ($[3] !== size) {
    t3 = {
      height: size,
      width: size
    };
    $[3] = size;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== animationStart || $[6] !== checkPath || $[7] !== circlePath || $[8] !== onComplete || $[9] !== scale || $[10] !== size) {
    t4 = animationStart && <motion.svg initial="hidden" animate="visible" exit="hidden" onAnimationComplete={onComplete} width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none" xmlns="http://www.w3.org/2000/svg"><motion.path d={checkPath} stroke={successColor} strokeWidth={3 * scale} strokeLinecap="round" strokeLinejoin="round" fill="none" initial={{
        pathLength: 0,
        opacity: 0
      }} animate={{
        pathLength: 1,
        opacity: 1
      }} transition={{
        pathLength: {
          duration: 0.4,
          ease: easeInOut
        },
        opacity: {
          duration: 0.01,
          ease: easeInOut
        }
      }} transform={`translate(${size / 2.8}, ${size / 3})`} /><motion.path d={circlePath} stroke={successColor} strokeWidth={3 * scale} strokeLinecap="round" strokeLinejoin="round" fill="none" initial={{
        pathLength: 0,
        pathOffset: 1,
        opacity: 0
      }} animate={{
        pathLength: 1,
        pathOffset: 0,
        opacity: 1
      }} transition={{
        pathLength: {
          duration: 0.3,
          ease: easeInOut,
          delay: 0.4
        },
        pathOffset: {
          duration: 0.3,
          ease: easeInOut,
          delay: 0.4
        },
        opacity: {
          duration: 0.01,
          delay: 0.4
        }
      }} transform={`translate(${size / 8}, ${size / 8})`} />{[{
        x: -size * 0.15,
        y: -size * 0.15
      }, {
        x: -size * 0.15,
        y: size * 0.15
      }, {
        x: size * 0.15,
        y: -size * 0.15
      }, {
        x: size * 0.15,
        y: size * 0.15
      }].map((position, index) => <motion.g key={index} initial={{
        opacity: 0,
        scale: 0,
        x: size / 2,
        y: size / 2
      }} animate={{
        opacity: [0, 1, 0],
        scale: [0, 1, 0],
        x: size / 2 + position.x,
        y: size / 2 + position.y
      }} transition={{
        duration: 0.4,
        ease: easeInOut,
        delay: 0.6,
        times: [0, 0.5, 1]
      }}><circle cx={0} cy={0} r={scale * 3} fill={successColor} /></motion.g>)}</motion.svg>;
    $[5] = animationStart;
    $[6] = checkPath;
    $[7] = circlePath;
    $[8] = onComplete;
    $[9] = scale;
    $[10] = size;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <AnimatePresence>{t4}</AnimatePresence>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <div className="flex items-center justify-center" style={t3}>{t5}</div>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
export default SuccessCheck;